import { render, staticRenderFns } from "./InstallmentBatchTypeChangeActivationType.vue?vue&type=template&id=0bc69855&"
import script from "./InstallmentBatchTypeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./InstallmentBatchTypeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports